import { isNil } from 'lodash'

import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { Alert } from 'features/alerts/types/alert'
import { AdUnitAlert } from 'features/inventory/ad-unit/types/adUnitAlert'
import { AdUnitDTO } from 'features/inventory/api/types/adUnitDTO'
import { AdUnit } from 'features/inventory/types/adUnit'
import { DEFAULT_REFETCH_INTERVAL } from 'providers/tanstack-query/constants'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { gql } from 'providers/tanstack-query/utils'

type Data = {
  node: null | Pick<AdUnitDTO, 'fieldAlerts'>
}
type Variables = {
  id: AdUnitDTO['id']
}

export const useGetFreshAdUnitAlerts = ({
  adUnitId,
}: {
  adUnitId?: AdUnit['id']
}): Alert<AdUnitAlert>[] => {
  const { data } = useQuery<Variables, Data, Alert<AdUnitAlert>[]>({
    options: {
      enabled: adUnitId !== undefined,
      refetchInterval: DEFAULT_REFETCH_INTERVAL,
      select: ({ node }: Data): Alert<AdUnitAlert>[] => {
        if (isNil(node)) {
          return []
        }

        return alertsFromDTO<AdUnitAlert>(node.fieldAlerts)
      },
    },
    query: gql`
      query getFreshAdUnitAlerts($id: ID!) {
        node(id: $id) {
          ... on AdUnit {
            fieldAlerts {
              name
              description
            }
          }
        }
      }
    `,
    variables: { id: adUnitId! },
  })

  return data ?? []
}
